import React, { ReactElement } from 'react'
import { Form, useFormikContext } from 'formik'
import { Button, Stack } from '@mindfulchefuk/design-system'
import {
  FormControl,
  FormInput,
  FormLabel,
  validateEmail,
} from '@mindfulchefuk/forms'
import { Spinner } from '@mindfulchefuk/components/Loader'

export const ForgotPasswordForm = (): ReactElement => {
  const { isSubmitting } = useFormikContext()

  return (
    <Form>
      <Stack spacing={{ base: 28, sm: 32 }} my={{ base: 24, sm: 32 }}>
        <FormControl
          type="email"
          id="email"
          name="email"
          validationSchema={validateEmail}
        >
          <FormLabel>Email address</FormLabel>
          <FormInput />
        </FormControl>

        <Button
          variant="primary"
          size="medium"
          disabled={isSubmitting}
          type="submit"
        >
          {isSubmitting ? <Spinner size={24} /> : 'Reset Password'}
        </Button>
      </Stack>
    </Form>
  )
}
